<template>
<div class="pad-bottom">
	<div class="hero">
		<v-layout row wrap align-center>
			<v-flex xs12 md6 offset-md3 class="profile-header" v-if="!editPhoto">
				<div class="profile-header__user-image">
					<img :src="user.avatar" alt="">
				</div>
				<p class="profile-header__user-name text-xs-center white--text">
					{{ user.first_name }}
					{{ user.last_name }}
				</p>
				<v-btn @click="editPhoto=true">Edit Photo</v-btn>
			</v-flex>
			<v-flex xs12 md6 offset-md3 class="profile-header" v-else>
				<profile-picture-upload v-on:noEditPhoto="editPhoto=false"></profile-picture-upload>
				<!-- <v-btn @click="editPhoto=false">Cancel</v-btn> -->
			</v-flex>
		</v-layout>
		<div class="clip-wrapper" style="pointer-events: none">
			<svg viewBox="0 0 1440 350" preserveAspectRatio="none" class="wave"><path d="M0,85 C0,85 170,235 675,105 C1180,-25 1440,85 1440,85 L1440,380 L0,380 L0,85 Z"></path></svg>
		</div>
	</div>
	<v-container fluid grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 sm10 offset-sm1 md6 offset-md3>
				<div>
					<a v-if="!editingBio" @click="editingBio=true" style="float: right">Edit</a>
					<v-btn v-else small flat color="link" @click="submitBio" style="float: right">Finish</v-btn>
					<div class="profile__section-header d-inline-block">Bio</div>
					<div class="caption gray--text">Your personal description, hosts and other users will see this</div>
				</div>
				<p class="mt-2" v-if="!editingBio" v-text="user.bio"></p>
				<v-textarea color="link" autofocus textarea rows="1" label="Edit Bio" class="mt-2 pl-2 pr-2" v-else v-model="bioText"></v-textarea>
				
				<div class="mt-5">
					<a v-if="!editingInterests" small dark @click="editingInterests=true" style="float: right">Edit</a>
					<v-btn v-else small flat color="link" @click="submitInterests" style="float: right">Finish</v-btn>
					<div class="profile__section-header d-inline-block">Interests</div>
					<div class="caption gray--text">Your occupational and other interests, e.g. Software Development, Hiking...</div>
				</div>
				<p class="mt-2" v-if="!editingInterests">
					<span v-for="i in interestsText" :key="i">{{ i }}<br></span>
				</p>
				<v-select
					color="link"
					v-else
					v-model="interestsText"
					label="Interests"
					deletable-chips
					chips
					tags
					:items="interestOptions"
				></v-select>
				

				<v-divider class="mt-5 mb-5"></v-divider>

				<div class="profile__section-header text-xs-center mt-2 mb-4">Settings</div>

				<router-link class="pull-right" :to="{name: 'host_dashboard'}" v-if="userIsHost">Manage your host settings &amp; profile</router-link>
				<router-link class="pull-right" :to="{name: 'host_info'}" v-if="!userIsHost">Become a host!</router-link>
				<p class="profile__section-header d-inline-block">Host Permissions</p>
				<p v-if="userIsHost" class="mt-2">You are approved to host and your account is in good standing!</p>
				<p v-else-if="userHasHostRequest" class="mt-2">Your host request has been received and is being evaluated. You should be hearing from us soon!</p>
				<p v-else class="mt-2">
					<router-link :to="{ name: 'host_info' }">Become a host!</router-link>
				</p>

				<v-divider class="mt-5 mb-5"></v-divider>

				<!-- <p class="profile__section-header">Linked Accounts</p>
				<p class="gray--text">You’ve connected the following accounts to authenticate with wrkprty, find friends, and to increase account verification level.</p>

				<v-list>
					<v-list-tile avatar v-for="acc in socialAccounts" v-bind:key="acc.id">
						<v-list-tile-avatar>
							<v-icon>fab fa-{{ acc.provider }}</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{ acc.provider }}</v-list-tile-title>
							<v-list-tile-sub-title>Added: {{ acc.date_joined }}</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon color="success">fas fa-check</v-icon>
						</v-list-tile-action>
					</v-list-tile>
					<v-list-tile disabled avatar v-if="!socialAccounts.find(obj => obj.provider === 'linkedin')" @click="authenticate('linkedin')">
						<v-list-tile-avatar>
							<v-icon>fab fa-linkedin</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>LinkedIn</v-list-tile-title>
							<v-list-tile-sub-title>Connect LinkedIn</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon color="info">fas fa-plus</v-icon>
						</v-list-tile-action>
					</v-list-tile>
					<v-list-tile avatar v-if="!socialAccounts.find(obj => obj.provider === 'facebook')" @click="authenticate('facebook_connect')">
						<v-list-tile-avatar>
							<v-icon>fab fa-facebook</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>Facebook</v-list-tile-title>
							<v-list-tile-sub-title>Connect Facebook</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon color="info">fas fa-plus</v-icon>
						</v-list-tile-action>
					</v-list-tile>
					<v-list-tile disabled avatar v-if="!socialAccounts.find(obj => obj.provider === 'google')">
						<v-list-tile-avatar>
							<v-icon>fab fa-google</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>facebook</v-list-tile-title>
							<v-list-tile-sub-title>Connect Google</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon color="info">fas fa-plus</v-icon>
						</v-list-tile-action>
					</v-list-tile>
				</v-list>

				<v-divider class="mt-5 mb-5"></v-divider> -->

				<!-- <p class="profile__section-header">Emails</p>

				<v-divider class="mt-5 mb-5"></v-divider> -->

				<p class="profile__section-header">Change password</p>
				<v-form v-model="valid" ref="form" lazy-validation>
					<v-text-field
						v-model="oldPassword"
						label="Old Password (if applicable)"
						min="8"
						:append-icon="e1 ? 'visibility' : 'visibility_off'"
						:append-icon-cb="() => (e1 = !e1)"
						:type="e1 ? 'password' : 'text'"
						counter
					></v-text-field>
					<v-text-field
						v-model="newPassword"
						label="New Password"
						min="8"
						:rules="[rules.required, rules.min_length, rules.include_lower, rules.include_upper, rules.include_number, rules.include_special]"
						:append-icon="e2 ? 'visibility' : 'visibility_off'"
						:append-icon-cb="() => (e2 = !e2)"
						:type="e2 ? 'password' : 'text'"
						counter
					></v-text-field>
					<v-text-field
						v-model="confirmPassword"
						label="Confirm Password"
						min="8"
						:rules="[rules.required, rules.password_match]"
						:append-icon="e3 ? 'visibility' : 'visibility_off'"
						:append-icon-cb="() => (e3 = !e3)"
						:type="e3 ? 'password' : 'text'"
						counter
					></v-text-field>
					<div
						style="color: red;"
						v-for="e in error"
						:key="e"
					>
						{{ e }}
					</div>
					<div style="color: green;">
						{{ success }}
					</div>
					<v-btn @click="update" :disabled="!valid">
						Update Password
					</v-btn>
				</v-form>

				<v-divider class="mt-5 mb-5"></v-divider>

				<p class="profile__section-header">Payment Settings</p>

				<p>Member Level: <strong>{{ user.is_premium ? 'Premium' : 'Member' }}</strong></p>

				<p v-if="user.is_premium">Please <a href="mailto:support@wrkprty.com">email support@wrkprty.com</a> to cancel membership</p>

				<!-- <v-btn v-if="!user.is_premium" @click="$router.push()" color="success">
					Get Premium
				</v-btn> -->

				<v-divider class="mt-5 mb-5"></v-divider>

				<p class="profile__section-header">Disable Account</p>
				<a href="mailto:support@wrkprty.com?subject=WRKPRTY%20Close%20Account%20Request">Email support@wrkprty.com</a> to disable your account.

				<v-divider class="mt-5 mb-5"></v-divider>

				<p class="profile__section-header">Legal</p>
				<a @click="setModalOpen({prop: 'termsModal', value: true})">Terms &amp; Conditions</a>

			</v-flex>
		</v-layout>
	</v-container>
</div>
</template>

<script>
import axios from 'axios'

import ProfilePictureUpload from '~/components/ProfilePictureUpload.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
	middleware: 'requireAuth',
	components: {
		ProfilePictureUpload
	},
	data() {
		return {
			editPhoto: false,
			editingBio: false,
			bioText: '',
			editingInterests: false,
			interestsText: null,
			interestOptions: [
				'Angel Investing',
				'Animation',
				'Art',
				'Cinematography',
				'Community Development',
				'Construction',
				'Consulting',
				'Entrepreneurship',
				'Filmmaking',
				'Films',
				'Finance',
				'Food',
				'Hack-a-thons',
				'Insurance',
				'Marketing',
				'Photography',
				'Politics',
				'Programming',
				'Real Estate',
				'Restaurants',
				'Robotics',
				'Sales',
				'Science',
				'Sports',
				'Startups',
				'Tech',
				'Transportation',
				'Travel',
				'Venture Capital',
				'Visual Effects',
				'Writing'
			],
			socialAccounts: [],
			e1: true,
			e2: true,
			e3: true,
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			error: [],
			success: '',
			valid: true,
			rules: {
				required: value => !!value || 'Required.',
				min_length: value =>
					value.length > 7 || 'Minimum length is 8 characters',
				include_lower: value => {
					return /.*[a-z].*/.test(value) || 'Must include a lowercase letter'
				},
				include_upper: value => {
					return /.*[A-Z].*/.test(value) || 'Must include an uppercase letter'
				},
				include_number: value => {
					return /.*[0-9].*/.test(value) || 'Must include a number'
				},
				include_special: value => {
					return (
						/.*[!@#$%^*?&~=+|\\\/\(\)\{\[\]}\-_\<\>\.].*/.test(value) ||
						'Must include a special character'
					)
				},
				password_match: value => {
					return this.newPassword === value || "Passwords don't match"
				}
			}
		}
	},
	created() {
		this.interestsText = this.user.interests.split(',')
		this.bioText = this.user.bio
		axios
			.get('/rest-auth/socialaccounts/')
			.then(response => {
				console.log(response)
				this.socialAccounts = response.data
			})
			.catch(error => {
				console.error(error)
			})
	},
	methods: {
		...mapActions([
			'setUserProp',
			'setModalOpen'
		]),
		authenticate: function (provider) {
			this.$auth.authenticate(provider)
				.then((response) => {
					axios
						.get('/rest-auth/socialaccounts/')
						.then(response => {
							this.socialAccounts = response.data
						})
						.catch(error => {
							console.error(error)
						})
				})
				.catch((error) => {
					console.error(error)
				})
		},
		submitBio() {
			let data = {
				username: this.user.username,
				bio: this.bioText
			}
			axios
				.put('/api/v1/user/' + this.user.pk + '/', data)
				.then(response => {
					console.log(response)
					this.setUserProp({ bio: response.data.bio })
					this.editingBio = false
				})
				.catch(error => {
					console.error(error)
				})
		},
		submitInterests() {
			let data = {
				username: this.user.username,
				interests: this.interestsText.join(',')
			}
			axios
				.put('/api/v1/user/' + this.user.pk + '/', data)
				.then(response => {
					console.log(response)
					this.setUserProp({ interests: response.data.interests })
					this.editingInterests = false
				})
				.catch(error => {
					console.error(error)
				})
		},
		update() {
			if (this.$refs.form.validate()) {
				if (this.newPassword === this.confirmPassword) {
					axios
						.put('/api/v1/settings/change-password/', {
							old_password: this.oldPassword ? this.oldPassword : '12345',
							new_password: this.newPassword
						})
						.then(response => {
							this.error = []
							this.success = response.data
						})
						.catch(error => {
							console.error(error)
							this.error = []
							for (let i in error.response.data) {
								this.error.push(error.response.data[i])
							}
						})
				} else {
					this.error = ['Password and confirmation do not match']
				}
			}
		}
	},
	computed: {
		...mapGetters(['user', 'userHasHostRequest', 'userIsHost'])
	}
}
</script>

<style lang="scss" scoped>
.profile__section-header {
	font-size: 1.6em;
	color: #444;
}

.pad-bottom {
	padding-bottom: 75px;
}

.profile-header {
	text-align: center;
	&__user-image {
		width: 100%;
		padding: 2px;

		overflow: hidden;
		text-align: center;
		img {
			object-fit: cover;
			border: 5px solid #fafafa;
			border-radius: 50%;
			width: 50%;
			max-width: 200px;
		}
	}

	&__user-name {
		font-size: 2em;
	}
}

.hero {
	overflow: hidden;
	height: 70vh;
	min-height: 500px;
	width: 100%;
	position: relative;
	background: linear-gradient(to bottom, #72a5d3 0%, #2fe789 100%);
	// background-color: $slate;
	display: flex;
	justify-content: center;
	align-items: center;
}

.clip-wrapper {
	position: absolute;
	width: 100%;
	height: 100%;
	clip: rect(0, auto, auto, 0);
	.icon {
		z-index: 999;
	}
}
.wave {
	width: 100%;
	height: 20vh;
	min-height: 100px;
	position: absolute;
	bottom: -1px;
	transform: scaleY(1);
	transform-origin: bottom;
	path {
		fill: #fafafa;
		stroke: none;
		transition: 5s;
		animation: path 20s ease-in-out alternate infinite;
	}
}

@keyframes path {
	0% {
		d: path(
			'M0,85 C0,85 170,235 675,105 C1180,-25 1440,85 1440,85 L1440,380 L0,380 L0,85 Z'
		);
	}
	100% {
		d: path(
			'M0,85 C0,85 300,-75 675,105 C1050,285 1440,85 1440,85 L1440,380 L0,380 L0,85 Z'
		);
	}
}
</style>
